import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useTranslator } from '@jutro/locale';
import { ViewModelForm, useDataRefresh } from '@xengage/gw-portals-viewmodel-react';

import metadata from './MLCancellationsReportAdditionalFilter.metadata.json5';
import './MLCancellationsReportAdditionalFilter.messages';

const MLCancellationsReportAdditionalFilter = (props) => {
    const {
        filterData,
        updateFilterData,
        initiatorTypelist,
        cancelReasonTypelist
    } = props;
    const { refreshData } = useDataRefresh();
    const translator = useTranslator();
    const [initiators, updateInitiators] = useState([]);
    const [cancelReasons, updateCancelReasons] = useState([]);

    useEffect(() => {
        const initiatorAvailableValues = initiatorTypelist.codes.map((initiator) => {
            return {
                code: initiator.code,
                name: translator({
                    id: initiator.name,
                    defaultMessage: initiator.name
                })
            };
        });
        updateInitiators(initiatorAvailableValues);

        const cancelReasonAvailableValues = cancelReasonTypelist.codes.map((cancelReason) => {
            return {
                code: cancelReason.code,
                name: translator({
                    id: cancelReason.name,
                    defaultMessage: cancelReason.name
                })
            };
        });
        updateCancelReasons(cancelReasonAvailableValues);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onValueChange = (value, path) => {
        _.set(filterData, path, value);
        updateFilterData(filterData);
        refreshData();
    }

    const overrideProps = {
        initiator: {
            availableValues: initiators,
            onValueChange
        },
        cancelReason: {
            availableValues: cancelReasons,
            onValueChange
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            model={filterData}
        />
    );
};

MLCancellationsReportAdditionalFilter.propTypes = {
    filterData: PropTypes.shape({}).isRequired,
    updateFilterData: PropTypes.func.isRequired,
    claimStatusTypelist: PropTypes.array.isRequired
};

export default MLCancellationsReportAdditionalFilter;
